// extracted by mini-css-extract-plugin
export var container = "_o4-0";
export var dotAnimation = "_o4-2";
export var dotsLoading = "_o4-1";